export const THEME_OVERRIDES = {
  common: {
    primaryColor: '#202124',
    primaryColorHover: '#3c4043',
    primaryColorPressed: '#000000',
    primaryColorSuppl: '#3c4043',
    successColor: '#188038',
    successColorHover: '#1e8e3e',
    successColorPressed: '#137333',
    successColorSuppl: '#1e8e3e',
    errorColor: '#c5221f',
    errorColorHover: '#d93025',
    errorColorPressed: '#b41412',
    errorColorSuppl: '#d93025'
  }
}
